import { Reference } from '@approvalmax/types';
import { mathService, numberHelpers } from '@approvalmax/utils';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { netSuiteExpenseItemsState, netSuiteItemLinesState } from '../../resources/states';
import { useCurrencyPrecision } from '../useCurrencyPrecision/useCurrencyPrecision';

export const useCalculatedAmount = (currency: Reference | null | undefined) => {
    const expenses = useAtomValue(netSuiteExpenseItemsState);
    const itemLines = useAtomValue(netSuiteItemLinesState);

    const currencyPrecision = useCurrencyPrecision(currency);

    const amount = useMemo(() => {
        const taxAmount = mathService.add(
            expenses.reduce(
                (accumulator, expense) =>
                    numberHelpers.isNumber(expense.taxAmount)
                        ? mathService.add(accumulator, expense.taxAmount)
                        : accumulator,
                0
            ),
            itemLines.reduce(
                (accumulator, item) =>
                    numberHelpers.isNumber(item.taxAmount) ? mathService.add(accumulator, item.taxAmount) : accumulator,
                0
            )
        );

        const netAmount = mathService.add(
            expenses.reduce(
                (accumulator, expense) =>
                    numberHelpers.isNumber(expense.amount) ? mathService.add(accumulator, expense.amount) : accumulator,
                0
            ),
            itemLines.reduce(
                (accumulator, item) =>
                    numberHelpers.isNumber(item.amount) ? mathService.add(accumulator, item.amount) : accumulator,
                0
            )
        );

        const totalAmount = mathService.round(mathService.add(netAmount, taxAmount), currencyPrecision);

        return {
            taxAmount,
            netAmount,
            totalAmount,
        };
    }, [expenses, itemLines, currencyPrecision]);

    return amount;
};
